<template>
    <tr
        :class="`${
            isEditRequested ||
            isViewDetailsRequested ||
            isDeleteRequested ||
            isActivateRequested ||
            isInactivateRequested
                ? 'edit-row'
                : ''
        }`"
    >
        <td><EmptyTextHandler :text="implantableDevice.Udi" /></td>
        <td><EmptyTextHandler :text="implantableDevice.Name" /></td>
        <td v-if="!isEditRequested && !isDeleteRequested && !isActivateRequested && !isInactivateRequested">
            <EmptyTextHandler :text="formatDate(implantableDevice.DateOfImplant)" />
        </td>
        <td class="w-25" v-if="isEditRequested && !isDeleteRequested && !isActivateRequested && !isInactivateRequested">
            <DatePicker :getDate="handleDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        type="text"
                        name="date-of-implant"
                        class="form-control"
                        :value="formatDateInput(implantableDevice.DateOfImplant)"
                        placeholder="MM/DD/YYYY"
                        autocomplete="off"
                        @change="handleDateInputChange"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <td
            class="text-end w-10"
            v-if="
                !isEditRequested &&
                !isActivateRequested &&
                !isInactivateRequested &&
                !isViewDetailsRequested &&
                !isDeleteRequested
            "
        >
            <button type="button" class="btn table-btn btn-outline-info" @click="openEdit()">
                <i class="fas fa-edit"></i>
            </button>
            <button type="button" class="btn table-btn btn-outline-danger" @click="requestDelete()">
                <i class="fas fa-trash-alt"></i>
            </button>
            <div class="btn-group table-btn-group">
                <button
                    type="button"
                    class="btn px-1 py-0 btn-outline-primary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    :id="`ConsentRow__Actions${implantableDevice.Id}`"
                >
                    <i class="fas fa-ellipsis-h"></i>
                </button>
                <div class="dropdown-menu" :aria-labelledby="`ImplantableRow__Action${implantableDevice.Id}`">
                    <a class="dropdown-item" href="javascript:void(0);" @click="openViewDetails()"> View Details </a>
                    <a
                        class="dropdown-item"
                        href="javascript:void(0);"
                        @click="openConfirmActivate()"
                        v-if="deviceStatusEnumMap.checkEnumValue('Inactive', implantableDevice.DeviceStatus)"
                    >
                        Activate
                    </a>
                    <a
                        class="dropdown-item"
                        href="javascript:void(0);"
                        @click="openConfirmInactivate()"
                        v-if="deviceStatusEnumMap.checkEnumValue('Active', implantableDevice.DeviceStatus)"
                    >
                        Inactivate
                    </a>
                </div>
            </div>
        </td>
        <td class="text-end" v-if="isViewDetailsRequested">
            <i>View in Progress</i>
        </td>
        <td class="text-end" v-if="isEditRequested">
            <button
                type="button"
                class="btn table-btn btn-success me-2"
                v-if="!isEditInProgress"
                @click="updateImplantableDevice()"
            >
                Save
            </button>
            <button type="button" class="btn table-btn btn-secondary" @click="closeEdit()" v-if="!isEditInProgress">
                Cancel
            </button>
            <div class="big-text text-primary" v-else>
                <i class="fas fa-save animated slow flash infinite me-1"></i>
                <b>Save in Progress...</b>
            </div>
        </td>
        <td v-if="isActivateRequested" :colspan="2">
            <TablePrompt
                ok-text="Activate"
                name="activate"
                :is-in-progress="isActivateInProgress"
                :ok="activateDevice"
                :cancel="closeConfirmActivate"
                btn-class="success"
            >
            </TablePrompt>
        </td>
        <td v-if="isDeleteRequested" :colspan="2">
            <TablePrompt
                ok-text="Delete"
                name="delete"
                :is-in-progress="isDeleteInProgress"
                :ok="deleteDevice"
                :cancel="closeRequestDelete"
            >
            </TablePrompt>
        </td>
        <td v-if="isInactivateRequested" :colspan="2">
            <TablePrompt
                ok-text="Inactivate"
                name="activate"
                :is-in-progress="isInactivateInProgress"
                :ok="inactivateDevice"
                :cancel="closeConfirmInactivate"
                btn-class="danger"
            >
            </TablePrompt>
        </td>
    </tr>
    <tr class="edit-row" v-if="isViewDetailsRequested">
        <td :colspan="columns" class="p-2 edit">
            <ImplantableValidationSection :implantable-device="implantableDevice"></ImplantableValidationSection>
            <div class="text-center">
                <button type="button" class="btn btn-outline-secondary btn-md ms-2 mt-1" @click="closeViewDetails()">
                    Cancel
                </button>
            </div>
        </td>
    </tr>
</template>

<script src="./ImplantableDeviceRow.ts"></script>
